import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { FilterDropdown, ListComponent } from "../../../common/component/Index";
import { Icon, Menu, message, Tooltip } from "antd";
import EllipsisText from "../../../common/component/EllipsisText";
import { DATE_TIME_FORMAT, PATHS } from "../../../../../constants/Define";
import moment from "moment";
import { columnsTable, getTitleTable } from "../../../../../helpers/functions";
import Inventory from "../../../../../models/Inventory";
import * as Func from "../../../../../helpers/functions";
import Dropdown from "../../../common/component/Dropdown";
import { Link } from "react-router-dom";
import Modal from "../../../common/component/Modal";
import { useTranslation } from "react-i18next";
import * as WarehouseService from "services/warehouseService";
import i18n from "constants/initLng";

const propTypes = {};

const InventoryList = (props) => {
  const {
    loading,
    inventory,
    pagination,
    permisions,
    getListInventory,
    params,
    onChange,
  } = props;
  //! State
  const ListCols = [
    "goodReceiptCode",
    "materialCode",
    "materialName",
    "supplierName",
    "rangeDate",
    "quantity",
    "receiptsPayslipCreateDate",
    "createdByName",
  ];

  const titleItemTable = getTitleTable(ListCols, ["action"], []);
  const modelItem = Object.getOwnPropertyNames(new Inventory());
  const componentTable = {
    goodReceiptCode: {
      key: "goodReceiptCode",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        ></FilterDropdown>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#1890ff" : undefined }}
        />
      ),
      render: (text, record) => {
        return (
          <EllipsisText
            title={text}
            content={text}
            contentMaxWidth={250}
            overlayClassName={"max-width-500"}
            overlayComponent={Tooltip}
          />
        );
      },
    },
    materialCode: {
      key: "materialCode",
      width: 250,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        ></FilterDropdown>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#1890ff" : undefined }}
        />
      ),
      render: (text, record) => (
        <EllipsisText
          title={text}
          content={text}
          contentMaxWidth={250}
          overlayClassName={"max-width-500"}
          overlayComponent={Tooltip}
        />
      ),
    },
    materialName: {
      key: "materialName",
      width: 300,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        ></FilterDropdown>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#1890ff" : undefined }}
        />
      ),
      render: (text, record) => (
        <EllipsisText
          title={text}
          content={text}
          contentMaxWidth={250}
          overlayClassName={"max-width-500"}
          overlayComponent={Tooltip}
        />
      ),
    },
    supplierName: {
      sorter: (i, k) => i.supplierName.length - k.length,
      key: "supplierName",
      width: 300,
      render: (text, record) => (
        <EllipsisText
          title={text}
          content={text}
          contentMaxWidth={250}
          overlayClassName={"max-width-500"}
          overlayComponent={Tooltip}
        />
      ),
    },
    rangeDate: {
      key: "rangeDate",
      width: 200,
      render: (text, record) =>
        record.usedDateFrom &&
        record.usedDateTo &&
        Date.parse(record.usedDateFrom) > 0 &&
        Date.parse(record.usedDateTo) > 0
          ? `${moment(record.usedDateFrom).format(
              DATE_TIME_FORMAT.SHORT_DATE
            )} - ${moment(record.usedDateTo).format(
              DATE_TIME_FORMAT.SHORT_DATE
            )}`
          : "",
    },
    receiptsPayslipCreateDate: {
      render: (text, record) =>
        moment(moment.utc(record.createdDate).toDate()).format(
          DATE_TIME_FORMAT.SHORT_DATE
        ),
    },
    action: {
      fixed: "right",
      width: 100,
      align: "center",
      key: "action",
      render: (text, record) => renderEditComponent(record),
    },
  };
  const { t } = useTranslation();

  const renderEditComponent = (item) => {
    return (
      <Dropdown
        overlay={
          <Menu className="action-menu">
            {permisions && permisions.allowViewDetail && (
              <Menu.Item>
                <Link
                  to={Func.getPathWithParams(
                    PATHS.WAREHOUSEMANAGEMENT.DETAIL.path,
                    {
                      id: item.id,
                    }
                  )}
                  className={`mr-2`}
                >
                  <Icon
                    type={permisions.allowUpdate ? "form" : "eye"}
                    className="fs20 mr-1"
                  />
                  {permisions.allowUpdate ? t(`action.edit`) : t(`action.show`)}
                </Link>
              </Menu.Item>
            )}
            {/* {permisions && permisions.allowDelete && (
              <Menu.Item onClick={(e) => onRemove(item)}>
                <Icon type="delete" className="fs20 mr-1" />
                {t(`action.remove`)}
              </Menu.Item>
            )} */}
          </Menu>
        }
      >
        <Icon type="more" className="fs20 cursorPointer" />
      </Dropdown>
    );
  };

  //! Function

  // const onRemove = (item) => {
  //   const { confirm } = Modal;
  //   confirm({
  //     title: Func.formatValidation(
  //       t("validation.statusCode.code.7"),
  //       t(`item.tour.title`)
  //     ),
  //     okText: t(`action.remove`),
  //     cancelText: t(`action.cancel`),
  //     onOk: () => {
  //       onDelete(item);
  //     },
  //   });
  // };

  // const onDelete = async (item) => {
  //   try {
  //     const res = await WarehouseService.deleteGoodReceiptCode(item.id);
  //     if (res) {
  //       message.success(
  //         t(`item.warehousemanagement.successCode.DELETE_SUCCESS`)
  //       );
  //       getListInventory(params);
  //     }
  //   } catch (error) {
  //     const messageError = error && error?.data?.errors[0]?.code;
  //     if (messageError === "WH_GR_CANNOT_DELETE_GR_USED") {
  //       return message.error(
  //         i18n.t(
  //           `item.warehousemanagement.errorCode.WH_GR_CANNOT_DELETE_GR_USED`
  //         )
  //       );
  //     } else {
  //       return message.error(
  //         i18n.t(`item.warehousemanagement.errorCode.UNDEFINED_ERROR`)
  //       );
  //     }
  //   }
  // };
  //! Render
  return (
    <ListComponent
      tableKey="inventory-list"
      scroll={{ x: 3000 }}
      classParent="m-0"
      classChildren="p-0"
      rowKey={(record, k) => (record.id ? record.id : k)}
      loading={{ spinning: loading, size: "large" }}
      dataSource={Func.getDataSource(inventory || [], modelItem)}
      columns={columnsTable({
        titleTable: titleItemTable,
        component: componentTable,
        itemName: "warehousemanagement",
      })}
      onChange={onChange}
      pagination={{
        total: pagination.totalCount,
        totalPage: pagination.totalPage,
        defaultPageSize: pagination.pageSize,
        defaultCurrent: pagination.defaultCurrent,
      }}
      componentTableList={{}}
    />
  );
};

InventoryList.propTypes = propTypes;
export default InventoryList;
